import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { FetchErrorsListsReqEntity } from "../interface/observation-error";
import { StorageKeyEnum } from "../utils/enum";


export const getDefaultObservationErrorFilterReq = (): FetchErrorsListsReqEntity => ({
    searchByErrorWorkOrderNumber: null,
    searchByErrorNumber: null,
    searchByOrderRefNumber: null,
    searchByProjectName: null,
    selectedOfficeIds: null,
    selectedSMUserIds: null,
    pageSize: 10,
    pageNumber: 0,
    searchByErrorCreatedByUser: null,
    errorStartDate: null,
    errorEndDate: null,
    errorAssignStartDate: null,
    errorAssignEndDate: null,
    errorStatusIds: null,
    sortColumn: "createdAt",
    sortOrder: "desc",
    selectedErrorDueToIds: null
});

interface UseObservationErrorStoreEntity {
    filterReq: FetchErrorsListsReqEntity;
    setFilterReq: (filterReq: FetchErrorsListsReqEntity) => void;
    updateFilterReq: (filterReq: Partial<FetchErrorsListsReqEntity>) => void;
    setObservationErrorStatusFilter: (status: string) => void;
    resetFilterReq: () => void;
    clearPersistedFilterReq: () => void;
}

export const useObservationErrorStore = create<UseObservationErrorStoreEntity>()(
    persist(
        (set) => ({
            filterReq: getDefaultObservationErrorFilterReq(),
            setFilterReq: (filterReq) => set(() => ({ filterReq })),
            updateFilterReq: (filterReq) => set((state) => ({ filterReq: { ...state.filterReq, ...filterReq } })),
            setObservationErrorStatusFilter: (status) => set(() => ({
                filterReq: {
                    ...getDefaultObservationErrorFilterReq(),
                    errorStatusIds: [status]
                }
            })),
            resetFilterReq: () => set(() => ({ filterReq: getDefaultObservationErrorFilterReq() })),
            clearPersistedFilterReq: () => {
                set(() => ({ filterReq: getDefaultObservationErrorFilterReq() }));
                localStorage.removeItem(StorageKeyEnum.OBSERVATION_ERROR_STORE_KEY);
            }
        }),
        {
            name: StorageKeyEnum.OBSERVATION_ERROR_STORE_KEY,
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ filterReq: state.filterReq })
        }
    )
);
